<template>
  <sui-container>
    <user-details :data="userDetails" :token="token" />
    <mobile-clients :data="userClients" />
  </sui-container>
</template>

<script>
  import UserDetails from "./account-details/UserDetails";
  import MobileClients from "./account-details/MobileClients";
  export default {
    components: {MobileClients, UserDetails},
    props: ["userDetails", "token", "userClients"],
    name: "AccountDetails"
  }
</script>

<style scoped>
  .token {
    width: 100%
  }

</style>
